import React, { useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useTheme } from '~/ui/styled'
import { ColumnFlex, StartFlex, BetweenFlex, CenterFlex, Text, Button } from "~components/El"
import { SearchBar } from "~components/SearchBar"
import { FlatList } from "~widgets/flat-list"
import { useStores } from "~models"
import ContactListItem from "~/components/contact-list/components/contact-list-item"

const ContactListView: React.FC<{
    members: any[]
    onConfirm: (contacts: any[]) => void
    onClose: () => void
}> = ({ members = [],onConfirm, onClose }) => {
    const theme = useTheme()
    const { contactStore } = useStores()
    const [searchText, setSearchText] = useState("")
    const [selecteds, setSelecteds] = useState([])
    const data = contactStore.getContactListByKeyword(searchText)
    const onItemClick = useCallback((contact) => {
        const index = selecteds.findIndex(item => item.user_id === contact.user_id)
        if (index !== -1) {
            selecteds.splice(index, 1)
            setSelecteds([...selecteds])
        } else {
            selecteds.push(contact)
            setSelecteds([...selecteds])
        }
    }, [selecteds])
    
    const keyExtractor = useCallback((item, idx) => item.user_id || idx.toString(), [])
    return (
        <ColumnFlex
            width="100%"
            padding="20px"
            borderRadius="16px"
            bg={theme.colors.blockBackground}
        >
            <CenterFlex width="100%">
                <Text fontSize="16px" color={theme.colors.text} fontWeight={600}>邀请联系人进群</Text>
            </CenterFlex>
            <StartFlex mt="20px">
                <SearchBar
                    value={searchText}
                    placeholder="搜索联系人"
                    onChange={setSearchText}
                    onClear={() => setSearchText("")}
                />
            </StartFlex>
            <StartFlex style={{ maxHeight: 360 }}>
                <FlatList
                      data={data}
                      extraData={selecteds}
                      keyExtractor={keyExtractor}
                      style={{ flex: 1 }}
                      renderItem={({ item }) => {
                        return (
                          <ContactListItem members={members} contact={item} selecteds={selecteds} isSelectMode={true} onItemClick={onItemClick} />
                        )
                      }}
                    />
            </StartFlex>
            <BetweenFlex width="100%" mt="12px" gap="10px">
                <Button
                    flex="1"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.background}
                    onClick={onClose}
                >
                    <Text color={theme.colors.infoText} fontSize={16}>取消</Text>
                </Button>
                <Button
                    flex="1"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.primary}
                    disabled={selecteds.length === 0}
                    onClick={() => onConfirm(selecteds)}
                >
                    <Text color={theme.colors.textLight} fontSize={16}>确定</Text>
                </Button>
            </BetweenFlex>
        </ColumnFlex>
    )
}

export default observer(ContactListView)
